import React from "react";
import { NotificationMetrics } from "../../../../types/app/notificationTypes";
import styles from "./notifications.module.scss";

interface DeliveryFunnelProps {
  metrics: NotificationMetrics;
}

const DeliveryFunnel: React.FC<DeliveryFunnelProps> = ({ metrics }) => {
  const maximum = Math.max(metrics.sent, metrics.targeted, 1);
  const rows = [
    { label: "Sent", value: metrics.sent },
    { label: "Delivered", value: metrics.delivered },
    { label: "Opened", value: metrics.opened },
  ];

  return (
    <section className={styles["notification-detail__section"]}>
      <h3>Delivery funnel</h3>
      <div className={styles["delivery-funnel"]}>
        {rows.map((row) => (
          <div className={styles["delivery-funnel__row"]} key={row.label}>
            <span className={styles["delivery-funnel__label"]}>{row.label}</span>
            <div className={styles["delivery-funnel__track"]} aria-hidden="true">
              <span
                className={styles["delivery-funnel__bar"]}
                style={{ width: `${Math.round((row.value / maximum) * 100)}%` }}
              />
            </div>
            <span className={styles["delivery-funnel__value"]}>{row.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DeliveryFunnel;
